import React, { Component } from 'react'
import { Input,Select,Button } from 'antd'
import SearchRetrieve from '../common/SearchRetrieve.new';
import API_URL from '../../common/url';

export default class Filter extends Component {

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        if( key == 'customer') {
            const { value: id, text: name } = value;
            searchParams[`${key}id`] = id;
            searchParams[`${key}Name`] = name;
        }else {
            searchParams[key] = value;
        }
        onChange(searchParams);
    }

    render() {
        const {searchParams,search} = this.props
    return (
        <div>
        <div className="search-bar" style={{marginBottom:'5px',width:'100%',justifyContent:'space-between'}}>
            <div>
                <div className="search-item" style={{display:'inline-block'}}>
                    <label className="ui-label" style={{margin:'0 10px'}}>JDE项目号</label>
                    <Input
                        placeholder="请输入"
                        style={{width: 150}}
                        value={searchParams.businessUnit}
                        onChange={e => this.handleChange(e.target.value,'businessUnit')}
                    />
                </div>
                <div className="search-item" style={{display:'inline-block'}}>
                    <label className="ui-label">客户名称</label>
                    <SearchRetrieve
                        keyword='customerCompanyName'
                        style={{ width: 160 }}
                        placeholder="请输入客户名称检索"
                        value={searchParams.customerName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                        onChange={(option) => this.handleChange(option, 'customer')}
                    />
            </div>

            <div className="search-item" style={{display:'inline-block'}}>
                    <label className="ui-label" style={{margin:'0 10px'}}>客户JDE号</label>
                    <Input
                        placeholder="请输入"
                        style={{width: 150}}
                        value={searchParams.customerJdeCode}
                        onChange={e => this.handleChange(e.target.value,'customerJdeCode')}
                    />
                </div>

            </div>
            
            <div className="search-bar flex-end" >
                <div className="search-item">
                    <Button type="primary" onClick={search}>搜索</Button>
                    <Button type="primary" onClick={()=>{this.props.export()}}>导出</Button>
                </div>
            </div>
            
        </div>
    </div>
    )
    }
}



// WEBPACK FOOTER //
// ./src/components/activityitem/Filter.js